import script from "./asset-status-zone.vue?vue&type=script&lang=ts&setup=true"
export * from "./asset-status-zone.vue?vue&type=script&lang=ts&setup=true"

import "./asset-status-zone.vue?vue&type=style&index=0&id=90fbf482&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90fbf482"]])

export default __exports__